import serviceImage1 from "./assets/images/service-1.png";
import serviceImage2 from "./assets/images/service-2.png";
import serviceImage3 from "./assets/images/service-3.png";
import serviceImage4 from "./assets/images/service-4.png";
import serviceImage5 from "./assets/images/service-5.png";
import serviceImage6 from "./assets/images/service-6.png";
import workImage1 from "./assets/images/work1.png";
import workImage2 from "./assets/images/work2.png";
import workImage3 from "./assets/images/work3.png";
import workImage4 from "./assets/images/work4.png";
import workImage5 from "./assets/images/work5.png";
import workImage6 from "./assets/images/work6.png";
import workImage7 from "./assets/images/work7.png";
import workImage8 from "./assets/images/work8.png";
import workImage9 from "./assets/images/work9.png";
import workImage10 from "./assets/images/work10.png";
import workImage11 from "./assets/images/work11.png";
import workImage12 from "./assets/images/work12.png";
import reviewImage1 from "./assets/images/pic-1.png";
import reviewImage2 from "./assets/images/pic-2.png";
import reviewImage3 from "./assets/images/pic-3.png";

const service = [
  {
    img: serviceImage1,
    nikita: "Nail Art",
  },
  {
    img: serviceImage2,
    nikita: "Nail Extension",

  },
  {
    img: serviceImage3,
    nikita: "Extension Removal",

  },
  {
    img: serviceImage4,
    nikita: "Gel Nail Polish",

  },
  {
    img: serviceImage5,
    nikita: "Manicure",

  },
  {
    img: serviceImage6,
    nikita: "Pedicure",

  },
];



const work = [
  {
    img: workImage1,

  },
  {
    img: workImage2,

  },
  {
    img: workImage3,

  },
  {
    img: workImage4,

  },
  {
    img: workImage5,

  },
  {
    img: workImage6,

  },
  {
    img: workImage7,

  },
  {
    img: workImage8,

  },
  {
    img: workImage9,

  },
  {
    img: workImage10,

  },
  {
    img: workImage11,

  },
  {
    img: workImage12,

  },

];
const review = [
  {
    img: reviewImage1,
    nikita: "Vasundhara Murtha : Lovely Service, Great Ambience, friendly staff and amazing collection of designs. Had a great Experience",
  },
  {
    img: reviewImage2,
    nikita: "vaishnavi gunda : Good ambience, affordable prices, great service.",
  },
  {
    img: reviewImage3,
    nikita: "Baboos : This place is really amazing. Hygiene is very well maintained. Staff is well trained & good at their work.",
  },
];

export { service, work, review };
